// Which classification codes a measurement leaves out: the ones the viewer has switched off when the measurement is made.

// Mirrors how the material decides what to draw (PointCloudMaterial.recomputeClassification): the code's own entry, else code % 32, else
// DEFAULT. scheme: viewer.classifications. Returns the hidden codes in ascending order.
export function hiddenClassCodes(scheme){
	const hidden = [];
	if(!scheme) return hidden;
	for(let code = 0; code < 256; code++){
		const entry = scheme[code] || scheme[code % 32] || scheme.DEFAULT;
		if(entry && !entry.visible) hidden.push(code);
	}
	return hidden;
}

// A lookup per code for the point loop, or null when nothing is left out.
export function hiddenClassLookup(codes){
	if(!codes || codes.length === 0) return null;
	const lookup = new Uint8Array(256);
	for(const code of codes) lookup[code] = 1;
	return lookup;
}
